import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';



// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/services/rxjs-operators.ts